// <TenantCard> — Ring App Store tenant-picker entry.
//
// One card per workspace candidate, rendered in the pre-session
// /tenant-picker page. Click activates the workspace.

import type { TenantCandidate } from "@/types/tenant";
import "./tenant-card.css";

export interface TenantCardProps {
  candidate: TenantCandidate;
  onSelect(tenantId: string): void;
  disabled?: boolean;
}

function formatLastActive(iso: string | null): string {
  if (!iso) return "Never active";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "Unknown";
  return d.toLocaleString();
}

export function TenantCard({ candidate, onSelect, disabled }: TenantCardProps): JSX.Element {
  return (
    <button
      type="button"
      className="reb-tenant-card"
      onClick={() => onSelect(candidate.tenant_id)}
      disabled={disabled}
      aria-label={`Activate workspace ${candidate.display_name}`}
    >
      <div className="reb-tenant-card__name">{candidate.display_name}</div>
      <div className="reb-tenant-card__badges">
        <span className="reb-badge">
          {candidate.role_count} role{candidate.role_count === 1 ? "" : "s"}
        </span>
        <span className="reb-badge">
          {candidate.location_count} location{candidate.location_count === 1 ? "" : "s"}
        </span>
      </div>
      <div className="reb-tenant-card__meta">
        Last active: {formatLastActive(candidate.last_active_at)}
      </div>
    </button>
  );
}
